import { createClient } from "@supabase/supabase-js";

/**
 * The browser talks to Postgres directly. The anon key is public by design —
 * row-level security is what protects the data, so there is no API layer here
 * to write, deploy or keep in sync with the schema.
 */
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  { auth: { persistSession: true, autoRefreshToken: true } },
);

/** Analyses live in R2, not Postgres: a few hundred KB each, fetched on every
 *  open, and egress there is free. */
export const filesUrl = import.meta.env.VITE_FILES_URL as string;
